import React from 'react';
import './variables.css';
import './global.css';
import Header from './header';
import Footer from './Footer';
import { Container } from '@mui/material';

const Template = ({ children, footerProps }) => {
  return (
    <>
      <Header />
      <main>
        <Container>{children}</Container>
      </main>
      {footerProps && <Footer {...footerProps} />}
    </>
  );
};

export default Template;
